import { DamageComplaintReportConstants } from '../constants';

export function DamageComplaintReport(state = {}, action) {
    switch (action.type) {
        case DamageComplaintReportConstants.LOADING_REQUEST:
            return {
                ...state,
                loading: action.isbool
            };
        case DamageComplaintReportConstants.GETALL_REQUEST:
            return {
                ...state,
                loading: true
            };
        case DamageComplaintReportConstants.GETALL_SUCCESS:
            return {
                ...state,
                items: action.datas
            };
        case DamageComplaintReportConstants.GETALL_FAILURE:
            return {
                ...state,
                error: action.error
            };
        case DamageComplaintReportConstants.GETEXPORT_REQUEST:
            return {
                ...state,
                exporting: true
            };
        case DamageComplaintReportConstants.GETEXPORT_SUCCESS:
            return {
                ...state,
                exportitems: action.datas
            };
        case DamageComplaintReportConstants.GETEXPORT_FAILURE:
            return {
                ...state,
                error: action.error
            };
        default:
            return state
    }

}